import { createStandardAction, ActionType } from 'typesafe-actions';
import { AccountManagementTab } from './AccountManagementState';

export const AccountManagementBlockActions = {
  setTab: createStandardAction('@quote/tab/set')<AccountManagementTab>(),
};

export type AccountManagementBlockAction = ActionType<typeof AccountManagementBlockActions>;
